import React, { createContext, useState, useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';

export const UserCreateEditContext = createContext();

export const UserCreateEditProvider = ({ children }) => {
  const [userCreateEditDetails, setUserCreateEditDetails] = useState({});

  const updateUserCreateEditDetails = useCallback((details) => {
    setUserCreateEditDetails(details);
  }, []);

  const value = useMemo(
    () => ({
      userCreateEditDetails,
      updateUserCreateEditDetails,
    }),
    [userCreateEditDetails, updateUserCreateEditDetails],
  );

  return <UserCreateEditContext.Provider value={value}>{children}</UserCreateEditContext.Provider>;
};

UserCreateEditProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
